/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyKroneSwedish = createReactComponent("outline", "currency-krone-swedish", "IconCurrencyKroneSwedish", [["path", { "d": "M5 6v12", "key": "svg-0" }], ["path", { "d": "M5 12c3.5 0 6 -3 6 -6", "key": "svg-1" }], ["path", { "d": "M5 12c3.5 0 6 3 6 6", "key": "svg-2" }], ["path", { "d": "M15 10v8", "key": "svg-3" }], ["path", { "d": "M19 10a4 4 0 0 0 -4 4", "key": "svg-4" }]]);

export { IconCurrencyKroneSwedish as default };
//# sourceMappingURL=IconCurrencyKroneSwedish.mjs.map
